import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import { Box, Button, SubHeading } from '@components/common';
import { InputField } from '@components/form';
import API from '@utils/api';
import { getErrors } from '@utils/error';

import validationSchema from './schema';

class ResetPasswordForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func
  };

  handleSubmit = async (values, actions) => {
    const { onSubmit } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);

    try {
      await API.updateCurrentPassword(values);
      setSubmitting(false);
      onSubmit();
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          passwordConfirm: error.message
        });
      } else {
        setErrors(error);
      }
    }
    setSubmitting(false);
  };

  render() {
    return (
      <Formik
        initialValues={{ currentPassword: '', password: '' }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isValid, isSubmitting }) => {
          const { onCancel } = this.props;
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <SubHeading textAlign="center" fontWeight="bold" mt={4} mb={4}>
                  Change Password
                </SubHeading>

                <Field
                  component={InputField}
                  mb={4}
                  name="currentPassword"
                  type="password"
                  label="Current Password"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="password"
                  type="password"
                  label="Password"
                />
                <Field
                  component={InputField}
                  mb={4}
                  name="passwordConfirmation"
                  type="password"
                  label="Confirm Password"
                />
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={4}
                >
                  <Button
                    type="button"
                    onClick={onCancel}
                    variant="secondary"
                    mr={4}
                    flex={1}
                  >
                    Cancel
                  </Button>
                  <Button
                    flex={1}
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    Done
                  </Button>
                </Box>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

export default ResetPasswordForm;
